module.exports = __webpack_public_path__ + "img/VL_17_03.39ca0800.png";